import { render } from "./ArrowLeft.vue?vue&type=template&id=4814e038"
import script from "./ArrowLeft.vue?vue&type=script&lang=js"
export * from "./ArrowLeft.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/ArrowLeft.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4814e038"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4814e038', __exports__)) {
    api.reload('4814e038', __exports__)
  }
  
  module.hot.accept("./ArrowLeft.vue?vue&type=template&id=4814e038", () => {
    api.rerender('4814e038', render)
  })

}


export default __exports__